import { render, staticRenderFns } from "./GlyphGRotatedRight.vue?vue&type=template&id=d4cd8bc6"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.102.1__lodash@4_56aa1e7e5d1d518316f437ffcea05512/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports